import { AccessDeniedComponent } from './auth/pages/access-denied/access-denied.component';
import { AdministrationComponent } from './pages/administration/administration.component';
import { LoginErrorComponent } from './auth/pages/login-error/login-error.component';
import { LoggedInComponent } from './auth/pages/logged-in/logged-in.component';
import { CatalogComponent } from './pages/catalog/catalog.component';
import { canActivateAuthRole } from './auth/guards/auth.guard';
import { RoleComponent } from './shared/role/role.component';
import { HomeComponent } from './pages/home/home.component';
import { Routes } from '@angular/router';

export const routes: Routes = [
    {
        path: 'login-error',
        component: LoginErrorComponent
    },
    {
        path: 'access-denied',
        component: AccessDeniedComponent
    },
    {
        path: 'logged-in',
        component: LoggedInComponent
    },
    { 
        path: '', 
        redirectTo: 'home', 
        pathMatch: 'full' 
    },
    {
        path: 'home',
        component: HomeComponent,
        canActivate: [canActivateAuthRole],
        data: { roles: ["ds-catalog-user", "ds-catalog-administrator"] },
        children: [
            { 
                path: '',
                redirectTo: '',
                pathMatch: 'full'
            },
            {
                path: 'role',
                component: RoleComponent,
                canActivate: [canActivateAuthRole],
                data: { roles: ["ds-catalog-user", "ds-catalog-administrator"] }
            },
            { 
                path: 'administration', 
                component: AdministrationComponent,
                canActivate: [canActivateAuthRole],
                data: { roles: ["ds-catalog-administrator"] }
            },
            { 
                path: 'catalog', 
                component: CatalogComponent,
                canActivate: [canActivateAuthRole],
                data: { roles: ["ds-catalog-user", "ds-catalog-administrator"] }
            },
        ]
    }
];